<div *ngIf="flag == 'th'; else elsebanner">
    <app-page-header [isCurveGray]="false" header="{{language.menu3}}" *ngFor="let item of banner"
        [ngClass]="(item.no==0)?'carousel-item active':'carousel-item'"
        backgroundPath="{{!isMobile ? item.banner_image : item.banner_image_mobile}}">
    </app-page-header>
</div>
<ng-template #elsebanner>
    <app-page-header [isCurveGray]="false" header="{{language.menu3}}" *ngFor="let item of banner"
        [ngClass]="(item.no==0)?'carousel-item active':'carousel-item'"
        backgroundPath="{{!isMobile ? item.banner_image_en : item.banner_image_mobile}}">
    </app-page-header>
</ng-template>

<section class="content-inner">
    <div class="container">
        <section class="section section--group">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/icon-hand@2x.png">
                    </span>
                    <span class="text">
                        {{language.privatetitile1}}
                    </span>
                </h2>
            </header>
            <div class="info">
                <p>
                    {{language.privatdetail1}}
                </p>
                <p>
                    {{language.privatdetail2}}
                </p>
            </div>
        </section>

        <section class="section-group -highlight">
            <header>
                <h3 class="topic-title sub-title">{{language.privattitle1sub1}}</h3>
            </header>

            <div class="row">
                <div class="col-sm-4">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/private/icon1@2x.png" class="img-responsive" alt="icon 1">
                        </div>
                        <p>
                            {{language.privattitle1sub1menu1line1}}<br />{{language.privattitle1sub1menu1line2}}
                        </p>
                    </section>
                </div>
                <div class="col-sm-4">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/private/icon2@2x.png" class="img-responsive" alt="icon 2">
                        </div>
                        <p>
                            {{language.privattitle1sub1menu2line1}}<br />{{language.privattitle1sub1menu2line2}}
                        </p>
                    </section>
                </div>
                <div class="col-sm-4">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/private/icon3@2x.png" class="img-responsive" alt="icon 3">
                        </div>
                        <p>
                            {{language.privattitle1sub1menu3line1}}<br />{{language.privattitle1sub1menu3line2}}
                        </p>
                    </section>
                </div>
            </div>
        </section>

        <section class="section-group">
            <header>
                <h3 class="topic-title sub-title">{{language.privattitle1sub2}}</h3>
            </header>
            <div class="info adventage-list">
                <ol>
                    <li>
                        {{language.privattitle1sub2detailline1}}
                    </li>
                    <li>
                        {{language.privattitle1sub2detailline2}}
                    </li>
                    <li>
                        {{language.privattitle1sub2detailline3}}
                    </li>
                    <li>
                        {{language.privattitle1sub2detailline4}}
                    </li>
                </ol>
            </div>
        </section>

        <section class="section-group -service have-border">
            <section>
                <header>
                    <h2 class="topic-title">
                        <span rel="border-circle">
                            <img src="../assets/images/private/icon-headset@2x.png">
                        </span>
                        <span class="text">
                            {{language.privatetitile2}}
                        </span>
                    </h2>
                </header>

                <div class="row">
                    <div class="col-sm-4">
                        <section class="info">
                            <div class="photo round">
                                <img src="../assets/images/private/photo1.jpg" class="img-responsive" alt="รายสัปดาห์"
                                    style="max-width: 100%;">
                            </div>
                            <h3 class="topic-title sub-title">{{language.privatetitile2sub1}}</h3>
                            <ul class="list list-bullet">
                                <li>{{language.privatetitile2sub1list1}}</li>
                            </ul>
                        </section>
                    </div>
                    <div class="col-sm-4">
                        <section class="info">
                            <div class="photo round">
                                <img src="../assets/images/private/photo2.jpg" class="img-responsive" alt="รายเดือน"
                                    style="max-width: 100%;">
                            </div>
                            <h3 class="topic-title sub-title">{{language.privatetitile2sub2}}</h3>
                            <ul class="list list-bullet">
                                <li>{{language.privatetitile2sub2list1}}</li>
                                <li>{{language.privatetitile2sub2list2}}</li>
                                <li>{{language.privatetitile2sub2list3}}</li>
                                <li>{{language.privatetitile2sub2list4}}</li>
                                <li>{{language.privatetitile2sub2list5}}</li>
                                <li>{{language.privatetitile2sub2list6}}</li>
                                <li>{{language.privatetitile2sub2list7}}</li>
                                <li>{{language.privatetitile2sub2list8}}</li>
                            </ul>
                        </section>
                    </div>
                    <div class="col-sm-4">
                        <section class="info">
                            <div class="photo round">
                                <img src="../assets/images/private/photo3.jpg" class="img-responsive" alt="รายปี"
                                    style="max-width: 100%;">
                            </div>
                            <h3 class="topic-title sub-title">{{language.privatetitile2sub3}}</h3>
                            <ul class="list list-bullet">
                                <li>
                                    {{language.privatetitile2sub3list1}}
                                </li>
                                <li>
                                    {{language.privatetitile2sub3list2}}
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
                <!-- /.row -->

            </section>
        </section>

        <section class="section-group have-border">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/medium_@2x.png">
                    </span>
                    <span class="text">{{language.privatetitile3}}</span>
                </h2>
            </header>
            <div class="info mt-0">
                <div class="row">
                    <ul class="list-download list-unstyled" style="display: contents">
                        <li class="col-md-6 col-xl-4" *ngFor="let item of doc_list">
                            <div *ngIf="flag == 'th'; else elseEn">
                                <a href="{{item.filePath}}" target="_blank">

                                    <i class="fas fa-download mr-2 icon-color"></i>
                                    <span>{{item.fileName}}</span>

                                </a>
                            </div>
                            <ng-template #elseEn>
                                <a href="{{item.filePath_en}}" target="_blank">

                                    <i class="fas fa-download mr-2 icon-color"></i>
                                    <span>{{item.fileName_en}}</span>

                                </a>
                            </ng-template>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="section-group -portfolio have-border">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/icon-risks@2x.png">
                    </span>
                    <span class="text">
                        {{language.privatetitile4}}
                    </span>
                </h2>
                <p class="intro">
                    {{language.privatetitile4detail}}
                </p>
            </header>

            <section class="info">
                <header>
                    <span rel="border-circle">
                        <img src="../assets/images/private/low_@2x.png">
                    </span>
                    <div>
                        <h3 class="topic-title sub-title">{{language.privatetitile5}}</h3>
                        <p>
                            {{language.privatetitile5detail}}
                        </p>
                    </div>
                </header>

                <div class="photo">
                    <img *ngIf="flag == 'th'; else elseconservative" src="../assets/images/graph/conservative@2x.png"
                        class="img-responsive" alt="conservative portfolio" data-rjs="2" data-rjs-processed="true"
                        width="384" height="204">

                    <ng-template #elseconservative>
                        <img src="../assets/images/graph/conservative@2x-Eng.jpg" class="img-responsive"
                            alt="conservative portfolio" data-rjs="2" data-rjs-processed="true" width="384"
                            height="204">

                    </ng-template>
                </div>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.privatetitile5sub1}}</h3>
                    <p>
                        {{language.privatetitile5sub1detail}}
                    </p>
                </section>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.privatetitile5sub2}}</h3>
                    <p>{{language.privatetitile5sub2detail}}</p>
                </section>
            </section>

            <section class="info">
                <header>
                    <span rel="border-circle">
                        <img src="../assets/images/private/medium_@2x.png">
                    </span>
                    <h3 class="topic-title sub-title">{{language.privatetitile6}} </h3>
                    <p>
                        {{language.privatetitile6detail}}
                    </p>
                </header>

                <div class="photo">
                    <img *ngIf="flag == 'th'; else elsemoderate" src="../assets/images/graph/moderate@2x.png"
                        class="img-responsive" alt="moderate portfolio" data-rjs="2" data-rjs-processed="true"
                        width="384" height="204">

                    <ng-template #elsemoderate>
                        <img src="../assets/images/graph/moderate@2x-Eng.jpg" class="img-responsive"
                            alt="moderate portfolio" data-rjs="2" data-rjs-processed="true" width="384" height="204">

                    </ng-template>
                </div>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.privatetitile6sub1}}</h3>
                    <p>
                        {{language.privatetitile6sub1detail}}
                    </p>
                </section>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.privatetitile6sub2}}</h3>
                    <p>{{language.privatetitile6sub2detail}}</p>
                </section>

            </section>

            <section class="info">
                <header>
                    <span rel="border-circle">
                        <img src="../assets/images/private/high_@2x.png">
                    </span>
                    <h3 class="topic-title sub-title">{{language.privatetitile7}}</h3>
                    <p>
                        {{language.privatetitile7detail}}
                    </p>
                </header>

                <div class="photo">
                    <img *ngIf="flag == 'th'; else elseaggressive" src="../assets/images/graph/aggressive@2x.png"
                        class="img-responsive" alt="aggressive portfolio" data-rjs="2" data-rjs-processed="true"
                        width="384" height="204">

                    <ng-template #elseaggressive>
                        <img src="../assets/images/graph/aggressive@2x-Eng.jpg" class="img-responsive"
                            alt="aggressive portfolio" data-rjs="2" data-rjs-processed="true" width="384" height="204">
                    </ng-template>
                </div>
                <section class="group">
                    <h3 class="topic-title sub-title">{{language.privatetitile7sub1}}</h3>
                    <p>
                        {{language.privatetitile7sub1detail}}
                    </p>
                </section>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.privatetitile7sub2}}</h3>
                    <p>{{language.privatetitile7sub2detail}}</p>
                </section>
            </section>
        </section>

        <section class="section-group have-border">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/icon-phone_@2x.png" style="width: 21px;">
                    </span>
                    <span class="text">{{language.contaxtitle}}</span>
                </h2>
            </header>
            <div class="info mt-0">
                <p>
                    {{language.contaxaddressline1}}
                    <br> {{language.contaxaddressline2}}
                </p>
            </div>

            <div class="info mt-0">
                <p>
                    {{language.contaxdetail}}
                </p>
                <ul class="list list-inline list-contact">
                    <li>
                        <span rel="border-circle">
                            <img src="../assets/images/private/icon-phone@2x.png">
                        </span>
                        <span>{{language.contaxtel1}}</span>
                    </li>
                    <li>
                        <span rel="border-circle">
                            <img src="../assets/images/private/ic-fax@2x.png">
                        </span>
                        <span>{{language.contaxtel2}}</span>
                    </li>
                    <li>
                        <span rel="border-circle">
                            <img src="../assets/images/private/ic-mail@2x.png">
                        </span>
                        <a href="mailto:pd@one-asset.com"> {{language.contaxemail}}</a>
                    </li>
                </ul>
            </div>
        </section>

    </div>
</section>